module.exports = __webpack_public_path__ + "static/media/personal_folder_tip_1.00d75357.png";